import { render, staticRenderFns } from "./materialTypeSetting.vue?vue&type=template&id=254b0ff2&scoped=true&"
import script from "./materialTypeSetting.vue?vue&type=script&lang=js&"
export * from "./materialTypeSetting.vue?vue&type=script&lang=js&"
import style0 from "./materialTypeSetting.vue?vue&type=style&index=0&id=254b0ff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b0ff2",
  null
  
)

export default component.exports